import { render, staticRenderFns } from "./BaseFeelings.vue?vue&type=template&id=40add40a&scoped=true&"
import script from "./BaseFeelings.vue?vue&type=script&lang=js&"
export * from "./BaseFeelings.vue?vue&type=script&lang=js&"
import style0 from "./BaseFeelings.vue?vue&type=style&index=0&id=40add40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40add40a",
  null
  
)

export default component.exports